
export default function ProcessTimeline() {
  const steps = [
    {
      number: '01',
      title: 'Free Consultation',
      description:
        "Contact us for a free, no-obligation case review. We'll evaluate your situation and explain your rights.",
    },
    {
      number: '02',
      title: 'Case Investigation',
      description:
        'We gather medical records, employment documents, and evidence to build a strong case for your claim.',
    },
    {
      number: '03',
      title: 'File Your Claim',
      description:
        "We handle all paperwork and filing requirements with the Ohio Bureau of Workers' Compensation.",
    },
    {
      number: '04',
      title: 'Negotiate Settlement',
      description:
        'We advocate aggressively for maximum benefits, negotiating with employers and insurance companies.',
    },
    {
      number: '05',
      title: 'Secure Your Benefits',
      description:
        'We ensure you receive all entitled benefits including medical coverage, wage replacement, and compensation.',
    },
  ];

  return (
    <section className="py-24 bg-gradient-to-r from-white via-gray-50 to-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Your Workers' Compensation Journey
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            A clear, step-by-step process to secure the benefits you deserve
          </p>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-1 bg-teal-200 -translate-y-1/2"></div>

          <div className="grid grid-cols-1 lg:grid-cols-5 gap-8">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                <div
                  className={`flex flex-col items-center ${
                    index % 2 === 0 ? 'lg:mt-0' : 'lg:mt-24'
                  }`}
                >
                  <div className="relative z-10 w-20 h-20 flex items-center justify-center bg-teal-600 text-white rounded-full text-2xl font-bold shadow-lg mb-6">
                    {step.number}
                  </div>
                  <div className="bg-white rounded-xl shadow-lg p-6 text-center">
                    <h3 className="text-lg font-bold text-gray-900 mb-3">{step.title}</h3>
                    <p className="text-sm text-gray-600 leading-relaxed">{step.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
